<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>의학 보고서 작성 능력을 위한
                            <br>트링카 AI</h1>
                        <p>매우 효과적인 트링카 AI가 의학 및 과학 글 작성에 필요한 섬세함과 기술적 정밀도를 인식해 글이 보다 몰입감 있고 격식 있는 내용으로 출판 준비가 되도록 변형해 드립니다.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/medical.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>개별 맞춤형 솔루션
                        </h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>의료 기기 및 제약</li>
                            <li>생명공학 및 생명과학</li>
                            <li>아웃소싱된 연구</li>
                            <li>의학 및 과학 출판</li>
                            <li>규정 및 약사법</li>
                            <li>의료 커뮤니케이션 및 마케팅</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>글로벌
                        <br>사용자</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/j-j.png" alt="image">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/cigna.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/novartis.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/merck.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/abbvie.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/amgen.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/biogen.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/who.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/accelera.png" alt="image">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/pfizer.png" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>팀을 위한 고품질 글쓰기 지원</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카는 팀이 중요한 문서를 효율적으로 작성하는 동시에 품질을 보장하고 과학 글쓰기 규칙을 준수하도록 지원해 드립니다.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="medical" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>의학 맞춤법 검사 및 사전</h3>
                                    <p>트링카에 내장된 의학 사전에는 다양한 분야의 수천 가지에 이르는 용어가 수록되어 있습니다. 또한 본인의 소속 조직이 사용하는 어휘와 새 용어를 추가하여
                                        모든 커뮤니케이션에서 일관성을 유지하면서 글쓰기 지원 내용을 개인 맞춤화할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/StyleGuides.png" alt="style_guide" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>맞춤형 스타일 가이드 내장</h3>
                                    <p>트링카를 사용하면 AMA와 APA 같은 기술 스타일 가이드를 쉽게 준수할 수 있습니다. 클릭 몇 번이면 모든 글쓰기 기본 선호 설정을 수정할 수 있습니다.
                                        맞춤형 스타일 가이드를 사용하여 팀 간의 모든 커뮤니케이션도 표준화해 보세요.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/PublicationReadiness.svg" alt="publication-readiness-checks" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>손색없는 출판 준비</h3>
                                    <p>트링카는 20가지 이상의 출판 준비 요구 사항에 대해 연구 논문을 확인해 드립니다. 이로써 팀의 출판을 앞당겨 브랜드의 연구 포트폴리오를 더 빨리 강화할
                                        수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="ppc" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>표절 검사 </h3>
                                    <p>가장 진보된 텍스트 유사도 탐지 알고리즘인 iThenticate와 최대 규모의 유료 출판 데이터베이스를 통해 최고 품질의 표절 검사를 제공합니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/BulkEditingOperations.svg" alt="bulk-editing" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>대량 교정 작업</h3>
                                    <p>문서를 MS Word 형식으로 업로드하고 편안히 앉아 몇 분만 기다리면 트링카가 문서를 교정해 드립니다. 변경 사항이 추적 및 적용되어 교정이 끝난 파일을
                                        다운로드하여 검토하고 마무리 지으면 됩니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>종합 분석</h3>
                                    <p>효과적인 의사 결정을 위해 팀에서 트링카 사용방법 또는
                                        <br>풍부한 분석 기능을 사용하여 각 사용자의 활동을 상세하게
                                        <br>분석할 수 있습니다.
                                    </p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="easy-user" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>쉬운 사용자 관리</h3>
                                    <p>팀 계정을 사용하면 구성원을 쉽게 추가하거나 제거할 수 있습니다. 실시간으로 크레딧 및 사용 한도를 관리해 보세요. 그 대상이 팀원이든 아웃소싱한 인재이든, 트링카의 세분화된 제어 기능을 통해 액세스를 쉽고 안전하게 관리할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>전담 지원</h3>
                                    <p>전담 매니저가 배정되어 전화, 문서, 그리고 영상 등을 통해 트링카를
                                        <br>최대한 활용할 수 있도록 지원합니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>다양한 사용 사례 지원</h2>
                    <div class="HeadingSubLine"></div>
                    <p>특정 산업 및 역할에 맞는 사용 사례를 통해 트링카가 의학 글쓰기에서 발휘하는 진정한 위력을 알아보세요.</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>연구 논문 작성</h4>
                                <p>트링카의 글쓰기 지원은 연구 논문 및 커뮤니케이션에 맞추어 만들어졌습니다.</p>
                                <ul>
                                    <li>주제별 용어 수정</li>
                                    <li>스타일 가이드 기본 선호 설정</li>
                                    <li>출판 준비 확인</li>
                                    <li>저널 범위 매치</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>과학 사전 및 브랜드 어휘 사전</h4>
                                <p>트링카는 조직이 커뮤니케이션을 표준화하고 브랜드를 유지하도록 도와드립니다.</p>
                                <ul>
                                    <li>팀 또는 조직 사전의 개인 맞춤화</li>
                                    <li>과학 용어의 오류를 정확히 감지하고 수정</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>효과적인 브랜드 커뮤니케이션</h4>
                                <p>팀이 브랜드를 유지하면서 대상 고객에게 쉽게 도달할 수 있도록 도와드립니다.</p>
                                <ul>
                                    <li>어조 개선 및 명확성 향상</li>
                                    <li>기술적 표현 개선</li>
                                    <li>연결성이 떨어지는 조각 글 제거</li>
                                    <li>맞춤형 브랜드 스타일 가이드</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>연구 논문 검토</h4>
                                <p>출판 중심 기능을 사용하여 손쉽게 연구 포트폴리오를 구축해 보세요.</p>
                                <ul>
                                    <li>언어 품질 확인</li>
                                    <li>일관성 확인</li>
                                    <li>출판 준비 확인</li>
                                    <li>대량 교정 옵션</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>독점 소프트웨어 및 작업 흐름에 따른 통합</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>트링카의 손쉬운 통합으로 기존 소프트웨어 내에 있는 모든 혜택을 같이 누릴 수 있어 글 작성이 보다 효과적이고 생산적이게 이루어집니다.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>자바스크립트</h3>

                    <p>
                        브라우저나 애플리케이션에 작은 자바스크립트(JS) 코드 스니펫을 삽입하기만 하면 모든 팀 구성원이 트링카를 사용할 수 있습니다.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>API</h3>
                    <p>
                        트링카의 강력한 API는 기존 애플리케이션에서 트링카를 바로 사용하도록 도와드립니다. 간단한 API 아키텍처를 통해 손쉽게 통합 작업을 할 수 있습니다.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>온프레스미스
                        <span>(직접 설치)</span>
                    </h3>
                    <p>로컬 서버와 클라우드 서버를 막론하고 공공 기반 시설에서 트링카를 통해 효과적인 기록과 최대한의 기밀유지가 보장
                        <br>됩니다.
                    </p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>클라우드 에디터</h3>


                    <p>
                        안전한 웹 기반 어플리케이션으로 언제 어디서나 트링카의 잠재 능력을 최대한 활용할 수 있습니다.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>MS Word 추가 기능</h3>
                    <p>
                        MS Word로 전달되는 글 작성 팁 제안으로 팀의 생산성을 높여보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>브라우저 플러그인</h3>
                    <p>
                        즐겨 사용하는 모든 브라우저에 적합한 플러그인을 통해 모든 웹사이트에서 실시간 글쓰기 지원을 받아보세요.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>귀사에 적합한 맞춤형 비용</h2>
                </div>
                <p>트링카는 고객 고유의 요구사항에에 맞게 개별 사용자 또는 사용 용도에 따른 비용을 책정합니다.
                    <br>추가 비용 없이 사용자를 변경하고 사용 제한을 실시간으로 적용할 수 있습니다.
                    <br>고객과 협력하여 주문서 및 인보이스를 통해 개별 맞춤형 계약 및 단일 결제 옵션이 제공될 수 있도록 협력합니다.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>안전, 보안, 신뢰</h3>
                        <p>트링카는 데이터 보안과 개인 정보 보호를 최우선으로 생각합니다. 내 모든 데이터는 강력하게 암호화되어 안전하게 저장됩니다. 다른 사람은 내 데이터에 액세스할 수 없습니다.
                            <br>트링카는 글쓰기 제안을 받으면 데이터 저장을 제거하는 고유한 플랜을 제공해 드립니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe-secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>AI 소개</h3>
                        <p>트링카는 최신 머신러닝(ML) 및 자연어 처리(NLP) 기술을 사용하여 문법 오류를 식별하고 언어 향상을 제안합니다. 의학, 생명과학, 생물학, 물리학, 공학, 인문학, 비즈니스
                            및 예술을 포함한 1300개 이상의 주제 영역을 망라하며 모범적으로 작성된 논문 및 기사 수백만 건을 바탕으로 훈련되기에 해당 주제에 가장 적절한 제안을 제공합니다.</p>
                        <p>트링카는 장벽 없는 커뮤니케이션을 통해 미래를 만들어가고자 하는 깊은 열망을 품은
                            <br>언어학자, 의학 에디터, 데이터 과학자 및 엔지니어로 이루어진 팀이 개발했습니다.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>트링카로 비즈니스 커뮤니케이션을 혁신해 보세요</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">견적 문의</button>
</div>

<app-enterprise-modal></app-enterprise-modal>